import React from 'react';
import styled from 'styled-components';
import { ImpactReceipt } from 'shared/components';

export const Ir = ({ match: { params: { investmentId }}}) => {
  return <Main><ImpactReceipt investmentId={investmentId}/></Main>;
};

const Main = styled.div`
  width: 100%;
  height: auto;
  background-color: #F9F9F9;
`;
